import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { Enums } from "../../../helper/constants/enums";
import { getAllHolidayAction, getHolidayAction, HolidayChangeStatusACTION, insertUpdateHolidayAction } from "../../actions/settingActions/holidayAction";
const INITIAL_STATE = {
    Holidays: {
        data: {
            records: [],
            totalRecords: 0,
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    selectedHoliday: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    insertUpdateHoliday: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    changeStatusHoliday: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    }
};

const HolidayReducer = createSlice({
    name: "Holiday",
    initialState: INITIAL_STATE,
    reducers: {

        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetHolidaysState(state, action) {
            state.selectedHoliday = INITIAL_STATE.selectedHoliday;
            state.insertUpdateHoliday = INITIAL_STATE.insertUpdateHoliday;
            state.changeStatusHoliday = INITIAL_STATE.changeStatusHoliday;
        },
    },
    extraReducers: (builder) => {

        builder.addCase(getAllHolidayAction.fulfilled, (state, action) => {
            state.Holidays.data = action.payload.data;
            state.Holidays.apiMsg.status = action.meta.requestStatus;
            state.Holidays.apiMsg.message = "success";
        });
        builder.addCase(getAllHolidayAction.pending, (state, action) => {
            state.Holidays.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllHolidayAction.rejected, (state, action) => {
            state.Holidays.apiMsg.message = action.error.message;
            state.Holidays.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(getHolidayAction.fulfilled, (state, action) => {
            state.selectedHoliday.data = action.payload.data;
            state.selectedHoliday.apiMsg.status = action.meta.requestStatus;
            state.selectedHoliday.apiMsg.message = action.payload.message.message;
        });

        builder.addCase(getHolidayAction.pending, (state, action) => {
            state.selectedHoliday.data = null;
            state.selectedHoliday.apiMsg.message = action.meta.requestStatus;;
            state.selectedHoliday.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getHolidayAction.rejected, (state, action) => {
            state.selectedHoliday.apiMsg.message = action.error.message;
            state.selectedHoliday.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(
            insertUpdateHolidayAction.fulfilled,
            (state, action) => {

                if (action.meta.arg) {
                    const newData = action.meta.arg;
                    const existingRecords = state.Holidays.data.records;
                    console.log("existingRecords", existingRecords);

                    const index = existingRecords ? existingRecords.findIndex(record => record.holidayID === newData[0].holidayID) : -1;


                    if (index !== -1) {
                        existingRecords[index] = {
                            ...existingRecords[index],
                            fromDate: newData[0].fromDate,
                            toDate: newData[0].toDate,
                            active: newData[0].active
                        };
                    }
                    state.Holidays.data.records = existingRecords;
                }
                state.insertUpdateHoliday.data = action.meta.arg;
                state.insertUpdateHoliday.apiMsg.status = action.meta.requestStatus;
                state.insertUpdateHoliday.apiMsg.message = action.payload.message.message;
                console.log("...........", action.meta.arg);

                state.insertUpdateHoliday.newRecord = action.meta.arg[0].holidayID ? false : true;

                toast.success(action.payload.message.message, {
                    position: "bottom-center",
                    toastId: "success"
                });
            }
        );
        builder.addCase(
            insertUpdateHolidayAction.pending,
            (state, action) => {
                state.insertUpdateHoliday.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(
            insertUpdateHolidayAction.rejected,
            (state, action) => {

                state.insertUpdateHoliday.apiMsg.message = action.error.message;
                state.insertUpdateHoliday.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: "bottom-center",
                    toastId: "error"
                });
            }
        );


        builder.addCase(HolidayChangeStatusACTION.fulfilled, (state, action) => {
            if (action.meta.arg.StatusType === Enums.ChangeStatus.Delete) {
                const existingRecords = state.Holidays.data.records;
                const holidayIDToDelete = action.payload.data.Id;
                const updatedRecords = existingRecords.filter(record => record.holidayID !== holidayIDToDelete);
                state.Holidays.data.records = updatedRecords;
                state.Holidays.data.totalRecords = state.Holidays.data.totalRecords - 1;
            }
            else if (action.meta.arg.StatusType === Enums.ChangeStatus.Active) {
                const newData = action.meta.arg;
                const existingRecords = state.Holidays.data.records;

                const index = existingRecords.findIndex(record => record.holidayID === newData.Id);
                if (index !== -1) {
                    existingRecords[index] = {
                        ...existingRecords[index],
                        active: true,
                    };
                }
            }
            else if (action.meta.arg.StatusType === Enums.ChangeStatus.Inactive) {
                const newData = action.meta.arg;
                const existingRecords = state.Holidays.data.records;

                const index = existingRecords.findIndex(record => record.holidayID === newData.Id);
                if (index !== -1) {
                    existingRecords[index] = {
                        ...existingRecords[index],
                        active: false,
                    };
                }

            }
            state.changeStatusHoliday.apiMsg.status = action.meta.requestStatus;
            state.changeStatusHoliday.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(HolidayChangeStatusACTION.pending, (state, action) => {
            state.changeStatusHoliday.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(HolidayChangeStatusACTION.rejected, (state, action) => {
            state.changeStatusHoliday.apiMsg.message = action.error.message;
            state.changeStatusHoliday.apiMsg.status = action.meta.requestStatus;
        });
    }
});

export const { RESET, ResetHolidaysState } = HolidayReducer.actions;
export default HolidayReducer.reducer;